import { cleanPhoneDigits, checkPhone } from "../lib/validation";

/** Phone input with locked +91 prefix. value is the 10-digit string only. */
export default function PhoneInput({ value, onChange, error, testid, disabled = false }) {
    const handle = (e) => {
        const cleaned = cleanPhoneDigits(e.target.value);
        onChange(cleaned);
    };
    const status = checkPhone(value || "");
    const showError = error || (value && !status.ok ? status.error : null);
    return (
        <div>
            <div className={`flex items-stretch h-11 mt-2 rounded overflow-hidden border ${
                showError ? "border-red-700 focus-within:border-red-500" : "border-slate-700 focus-within:border-[#00FF66]"
            } bg-slate-900`}>
                <span className="flex items-center px-3 bg-slate-800 text-slate-300 font-bold text-sm select-none border-r border-slate-700">+91</span>
                <input
                    type="tel"
                    inputMode="numeric"
                    value={value || ""}
                    onChange={handle}
                    disabled={disabled}
                    maxLength={10}
                    placeholder="9876543210"
                    data-testid={testid}
                    className="flex-1 px-3 bg-slate-900 text-white placeholder:text-slate-600 focus:outline-none disabled:opacity-60"
                />
            </div>
            {showError && <p className="mt-1 text-xs text-red-400" data-testid={`${testid}-error`}>{showError}</p>}
        </div>
    );
}
